import styled from 'styled-components';

export const ItemPrice = styled.span`
  font-size: 1rem;
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.heavy};
  color: ${Styles.color.black};
`;
